module.exports = __webpack_public_path__ + "img/024.0e1ef1e8.png";